import { Env } from "../../env";

//  Create a Stripe client.
var elements = null;

//  Custom styling can be passed to options when creating an Element.
//  (Note that this demo uses a wider set of styles than the guide below.)
const cl = {
  base: "stripe_base",
  empty: "stripe_empty",
  focus: "stripe_focus",
  invalid: "stripe_invalid",
  complete: "stripe_complete",
};

const st = {
  base: {
    height: "30px",
    color: "#2196f3",
    lineHeight: "30px",
    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
    fontSmoothing: "antialiased",
    fontSize: "16px",
    "::placeholder": {
      color: "#aab7c4",
    },
  },
  invalid: {
    color: "#eb1c26",
    iconColor: "#eb1c26",
  },
};

var stripe = null;

if (typeof Stripe !== "undefined" && Env.ENABLE_STRIPE === "true") {
  //stripe = Stripe('pk_test_drJXey0YUJgqWTN0BvHhLSfz');
  stripe = Stripe("pk_live_XQJ4EUPA5APHo3DbnlG8c5sV");
  console.log("Stripe is defined ?", !!stripe);

  //  Create an instance of Elements.
  elements = stripe.elements();
}
//  Create an instance of the card Element.
export const card =
  typeof elements !== "undefined" && elements
    ? elements.create("card", { classes: cl, style: st })
    : null;

//  Add an instance of the card Element into the `card-element` <div>.
export function mountElement() {
  if (card && document.getElementById("card-element")) {
    card.mount("#card-element");
  } else {
    setTimeout(() => {
      mountElement();
    }, 100);
  }
}
export function createTokens(owneremail) {
  return new Promise((resolve, reject) => {
    const promise = stripe.createSource(card, { owner: { email: owneremail } });
    promise.then((result) => {
      // result.token is the card token.
      console.log("lllllllllllllllll" + result);
      //  console.log("lllllllllllllllll"+JSON.stringify(result));
      if (result.error) {
        reject(result.error);
        return;
      }
      resolve(result.source);
    });
  });
}



// WEBPACK FOOTER //
// ./src/pages/subscription/payment.js